import React from 'react'
import { Router } from 'react-router-dom'
import { ApolloProvider } from 'react-apollo'
import { StripeProvider } from 'react-stripe-elements';
import client from './src/client'

exports.replaceRouterComponent = ({ history }) => {
  const ConnectedRouterWrapper = ({ children }) => (
    <ApolloProvider client={client}>
      <StripeProvider apiKey={process.env.GATSBY_STRIPE_API_KEY}>
        <Router history={history}>{children}</Router>
      </StripeProvider>
    </ApolloProvider>
  )

  return ConnectedRouterWrapper
}


// WEBPACK FOOTER //
// ./gatsby-browser.js